import 'rxjs/add/operator/debounceTime';
import {ChangeDetectionStrategy, Component, HostListener, NgZone} from '@angular/core';
import {NavController, NavParams, ViewController} from 'ionic-angular';

import { CONFIG } from '../../../app/config';
import { TGoogleAnalytic, TStatusBar, Util} from "../../../app/util";
import { ENUM, TAcessoFind, TAction, TConviteTipo, TLoginTipo, TProfileAlma, TPaybookModo, TPaybookTipo, TPrinterTipo, TProdutoImpresso, TProdutoSale } from "../../../app/enum";
import { LogadoService } from "../../../providers/logado-service";
import { ConsumoSalePage } from '../consumo-sale/consumo-sale';
import { EntrakiOpenPage } from '../entraki-open/entraki-open';
import { PaybookMenuPage } from '../paybook-menu/paybook-menu';
import { RegeditMenuPage } from '../regedit-menu/regedit-menu';
import { ProfileAuthPage } from '../profile-auth/profile-auth';
import { LancakiMenuPage } from '../lancaki-menu/lancaki-menu';

@Component({
    selector: 'page-desktop-menu',
    templateUrl: 'desktop-menu.html',
    providers: [],
    changeDetection: ChangeDetectionStrategy.Default,
})
export class DesktopMenuPage {
    
    ENUM: any = ENUM;
    config: any = CONFIG;

    TProdutoSale: any = TProdutoSale;

    logado: any;
    etapa: number;
    hotspotID: number;

    akkjson = (window as any).handappMainInstance.appjson;
    monitorAuth = this.akkjson.hotwork;

    //Etapa - 3
    rootComanda: any = {Comandas: []};


    clusterZZZ: number = -1;
    produtoZZZ: number = -1;

    inputFocus: string = '';

    usuarioPinu: string = '';
    comandaText: string = '';

    requestErro: any;
    paybookSair: any;


    scannerData: string = '';
    @HostListener('window:keypress', ['$event'])
    keyEvent(event: KeyboardEvent) {
        this.barcodeRead(event);
    }

    constructor(public viewCtrl: ViewController, public navCtrl: NavController, public navParams: NavParams,
                public logadoService: LogadoService, public util: Util, private ngZone: NgZone) {

        this.logado = this.logadoService.getAuth();
        this.etapa = this.util.anyParams(null, this.navParams.get('etapa'));

        //
        this.hotspotID = this.util.anyParams(0, this.navParams.get('hotspotID'));

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Desktop', '/webstor/desktop-menu');

        //Hide Support Button Fab
        (window as any).handappMainInstance.supportShow = false;

    }

    ionViewDidLoad() {
        
    }

    ionViewDidEnter() {

        this.util.stylesBarOnoff(false);
        this.util.statusBarColor(TStatusBar.sbStyleLightContent);

    }

    barcodeRead(e) {
        
        if (e.key == 'Enter') {
            let scanerText = this.scannerData;
            scanerText = scanerText.replace('-', '').replace('-', '').replace('-', '').replace('-', '');
            scanerText = scanerText.replace('.', '').replace('.', '').replace('.', '').replace('.', '');

            this.scannerData = (ENUM.scannerRead(scanerText, this.monitorAuth.Hotspot.SettingBars)+'');
            this.comandaText = this.scannerData;
            this.tecladoOkey('ok');
            this.scannerData = '';
            return;
        }

        this.scannerData = this.scannerData + e.key;
      //this.scannerData = this.scannerData + String.fromCharCode(e.key);

    }
 





    carregaPage(page) {

        this.logadoService.logout();
        this.logado = this.logadoService.getAuth();

        this.etapa = page;

        if (this.etapa == 1) this.inputFocus = '';
        if (this.etapa == 2) this.inputFocus = 'inputPinu';
        if (this.etapa == 3) this.inputFocus = 'inputNoro';

        if (this.etapa > 1) setTimeout(() => this.tecladoOkey('erase'), 1000);

        this.ngZone.run(() => {});

    }

    tecladoOkey(btn) {
        
        if (!this.monitorAuth) return;

        this.comandaText = this.comandaText.replace('-', '').replace('-', '').replace('-', '').replace('-', '');
        this.comandaText = this.comandaText.replace('.', '').replace('.', '').replace('.', '').replace('.', '');

        if (btn == 'ok') {
                 if (this.etapa == 1 && this.inputFocus == 'inputNoro' && this.comandaText.length > 1) this.comandaFind();
            else if (this.etapa == 2 && this.inputFocus == 'inputPinu' && this.usuarioPinu.length > 1) this.inputFocus = 'inputNoro';
            else if (this.etapa == 2 && this.comandaText.length > 0    && this.usuarioPinu.length > 1) this.usuarioIpad();
            else if (this.etapa == 3 && this.inputFocus == 'inputNoro')                                this.comandaSair();
        }

        else if (btn == 'cancel') {
            this.dismiss();
        }

        else if (btn == 'erase') {
            this.usuarioPinu = '';
            this.comandaText = '';
            if (this.etapa == 1) this.inputFocus = 'inputNoro';
            if (this.etapa == 2) this.inputFocus = 'inputPinu';
            if (this.etapa == 3) this.inputFocus = 'inputNoro';
        }

        else if (btn == 'left-thin') {
            if (this.inputFocus == 'inputPinu') this.usuarioPinu = this.usuarioPinu.slice(0, this.usuarioPinu.length-1);
            if (this.inputFocus == 'inputNoro') this.comandaText = this.comandaText.slice(0, this.comandaText.length-1);
        }

        else if (btn == 'dot') {
            //if (this.inputFocus == 'inputPinu') this.usuarioPinu = this.usuarioPinu + '.';
            //if (this.inputFocus == 'inputNoro') this.comandaText = this.comandaText + '.';
        }

        else {
            if (this.inputFocus == 'inputPinu' && this.usuarioPinu.length < 5)  this.usuarioPinu = this.usuarioPinu + btn;
            if (this.inputFocus == 'inputNoro' && this.comandaText.length < 14) this.comandaText = this.comandaText + btn;
        }

        let tecladoText = this.comandaText;
        if (tecladoText.length <= 4) this.comandaText = tecladoText;
        if (tecladoText.length == 5) this.comandaText = tecladoText[0] + tecladoText[1] + '.' + tecladoText[2] + tecladoText[3] + tecladoText[4];
        if (tecladoText.length >= 6) this.comandaText = tecladoText[0] + tecladoText[1] + tecladoText[2] + '.' + tecladoText[3] + tecladoText[4] + (tecladoText[5] || '') + (tecladoText[6] ? '.' + tecladoText[6] : '') + (tecladoText[7] || '') + (tecladoText[8] || '') + (tecladoText[9] ? '-' + tecladoText[9] : '')  + (tecladoText[10] || '');

    }


    regeditMenu() {

        //#MonitorAuth - Login diretona rede local (GRAVA)
        let onLoad = () => this.monitorAuth = this.akkjson.hotwork;
        let object = {};
        this.util.modalopen(RegeditMenuPage, 'alto', false, object, null, null, onLoad).subscribe();

    }

    comandaCria(tecladoText, userset, paybookTipo: TPaybookTipo) {

        let hotspot = this.monitorAuth.Hotspot;
        let checkinNoro = parseInt((tecladoText+'').replace('.', ''));
                
        let object = {etapa: 1, monitorBool: true, hotspot: hotspot, userset: userset, profileDesk: null, checkinNoro: checkinNoro, spotdayID: 0, paybookTipo: paybookTipo, paybookModo: TPaybookModo.pmUser, checkinSelf: false, conviteTipo: TConviteTipo.ctConvitePorta};
        this.util.modalopen(EntrakiOpenPage, 'quad', true, object)
            .subscribe(done => {
                if (this.etapa == 1) this.comandaFind(); //EXCLUI ESSA LINHA SE DEPOIS QUE FIZER CHECKIN NAO FAZER NADA!
                if (this.etapa == 2) this.usuarioIpad();
            });

    }

    usuarioAuth() {

        /** 5 - PASSWORD **/
        let object = {etapa: 0, rootile: null, loginTipo: TLoginTipo.loPassword, justLogin: true, requestIpad: true};
        this.util.modalopen(ProfileAuthPage, 'alto', false, object).subscribe(
            data => {
                this.logado = this.logadoService.getAuth();
                this.inputFocus = 'inputNoro';
            }
        );
        
    }

    usuarioIpad() {

        //STARTED - Carrega o Hotspot do Monitor
        if (!this.monitorAuth) return;

        //Started Auth
        let proauth = {
            ProfileAuth: true,
            ProfileRnid: '',
            ProfileOito: '',
            ProfilePinu: this.usuarioPinu,
            Facebook:    null,
        };

        let onData = (data) => {

            //#LOGADO
            let profile = this.util.deepCopy(data.Usuarios[0].Profile);
            let rootile = {Sessao: data.Sessao, Profile: profile};
            this.logadoService.profileJson(TAction.acAuth, rootile);
    
            //#CLUSTER | //#ESCOLHA
            this.akkjson.hotwork.clusterRoot = {Clusters: data.Clusters, ConsumoPedy: data.ConsumoPedy, Escolhas: data.Escolhas};
            this.monitorAuth.clusterRoot = this.akkjson.hotwork.clusterRoot;
                                                

            if (this.etapa == 1) {
                this.logado = this.logadoService.getAuth();
                return;
            }

            let comandaTipo = (this.comandaText.length < 4 ? TPaybookTipo.pbMesa : TPaybookTipo.pbCard);

            //#COMANDA
            let comanda = (data.Comandas || [])[0];
            if (!comanda) {
                this.logadoService.logout();

                let paybook = (data.Comandas || [])[0];
                let userset = (data.Usuarios || [])[0];
                let paycria = (this.comandaText.length < 4 || this.monitorAuth.Hotspot.SettingAlma == TProfileAlma.paLancaki);
    
                if (!paybook &&  paycria) this.comandaCria(this.comandaText, userset, comandaTipo);
                if (!paybook && !paycria) this.util.toastSimply('Não encontrado');
    
                return;
            }

            this.rootComanda.Usuarios = data.Usuarios;
            this.rootComanda.Comandas = [comanda];
            this.rootComanda.Comandas[0].Consumos = [];

            
            //#MESA -> NÃO Pergunta a mesa (comanda é mesa)
            if (comandaTipo == TPaybookTipo.pbMesa) this.rootComanda.Comandas[0].Mesa = comanda.PaybookNoro;
                
            //#MESA -> NÃO Pergunta a mesa (sem ambient-mesa)
            if (comandaTipo == TPaybookTipo.pbCard && !comanda.Ambient.AmbientRoom) this.rootComanda.Comandas[0].Mesa = 0;

            if (this.rootComanda.Comandas[0].Mesa >= 0) {
                this.etapa = 10;
                return;
            }

            //#MESA -> Pergunta a mesa
            let object = {etapa: 5, monitorBool: true, requestIpad: true, hotspotID: this.hotspotID, rootComanda: this.rootComanda, comandaIN: 0, clusterIN: -1};
            this.util.modalopen(LancakiMenuPage, 'alto', false, object)
            .subscribe(data => {
                if (this.rootComanda.Comandas[0].Mesa != null) this.etapa = 10;
                if (this.rootComanda.Comandas[0].Mesa == null) this.dismiss();
            });

        };


        // Procria
        let loading = this.util.loadingDots();
        loading.present();

        let rnrn = this.util.validaCNPF(this.comandaText);
        let params = '&ComandaText=' + this.comandaText +                     
                     '&ComandaMode=' + (rnrn ? TAcessoFind.afFindRnid : TAcessoFind.afFindNoro);

        this.util.monitorDesk(true, 'DESK-Started', this.hotspotID, params, TAction.acIpad, {Proauth: proauth})
            .finally(() => loading.dismiss())
            .subscribe(
                data => onData(data),
                erro => this.util.alertResult(erro, () => this.tecladoOkey('erase'))
            );
    
    }




    getTitle() {

        if (this.etapa == 10) return 'Lançamento';

    }

    produtoOpen(rowline, produtoIX) {

        if (this.produtoZZZ != produtoIX) {
            this.produtoZZZ = produtoIX;
            return;
        }

        let comanda = this.util.deepCopy(this.rootComanda.Comandas[0]);
        this.rootComanda.Dividirs = [comanda];

        let cluster = this.monitorAuth.clusterRoot.Clusters[this.clusterZZZ];

        let object = {etapa: 6, monitorBool: true, hotspotID: this.hotspotID, rootComanda: this.rootComanda, comandaIN: 0, itemProduto: rowline, itemEscolha: cluster.ClusterText};
        this.util.modalopen(ConsumoSalePage, 'alto', false, object).subscribe(data => this.consumoLoad());

    }


    consumoLoad() {
        
        let paybook = this.rootComanda.Comandas[0];
        let params = '&ComandaID=' + paybook.ComandaID + '&ConsumoPedy=' + this.monitorAuth.clusterRoot.ConsumoPedy;

        this.util.monitorDesk(true, 'DESK-Consumo', this.hotspotID, params, TAction.acBook)            
            .subscribe(
                data => paybook.Consumos = data.Consumos,
                erro => this.util.alertResult(erro)
            );

    }

    consumoLixo(consumo) {

        let index = this.rootComanda.Comandas[0].Consumos.indexOf(consumo);

        let loading = this.util.loadingDots();
        loading.present();

        let params = '&ConsumoID=' + consumo.Consumo.ConsumoID;

        this.util.monitorDesk(true, 'DESK-Consumo', this.hotspotID, params, TAction.acLixo)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {
                    let array = this.rootComanda.Comandas[0].Consumos.filter(CS => (CS.Consumo.ConsumoID == consumo.Consumo.ConsumoID || CS.Consumo.ConsumoCB == consumo.Consumo.ConsumoID))
                                                            
                    array.forEach(CS => {
                        index = this.rootComanda.Comandas[0].Consumos.indexOf(CS);
                        this.rootComanda.Comandas[0].Consumos.splice(index, 1);
                    });
                },
                erro => this.util.alertResult(erro)
            );

    }

    //PRINTER
    printerItem() {

        if (!this.rootComanda.Comandas[0].Consumos.length) {
            this.dismiss();
            return;
        }

        let params = '&ConsumoPedy=' + this.monitorAuth.clusterRoot.ConsumoPedy + 
                     '&Impresso=' + TProdutoImpresso.piImpressoAguardando;

        this.util.monitorDesk(true, 'DESK-Printer', this.hotspotID, params, TAction.acItem)
            .subscribe(
                data => this.dismiss(),
                erro => this.util.alertResult(erro)
            );

    }

    //PRINTER
    printerLoad() {

        let onLoad = (data) => {
            /** OPEN **/
            let buttons: Array<any> = [];
            let array = data.Printers.filter(PR => PR.PrinterTipo == TPrinterTipo.ptPrinterTodos || PR.PrinterTipo == TPrinterTipo.ptPrinterBill);
            array.forEach(PR => buttons.push({text: PR.PrinterNome,  handler: () => this.printerBill(PR.PrinterID)}));
            this.util.sheetOpen(buttons, 'PRINTER', 0);
        };

        let loading = this.util.loadingDots();
        loading.present();

        this.util.monitorDesk(true, 'DESK-Printer', this.hotspotID, '', TAction.acLoad)
            .finally(() => loading.dismiss())
            .subscribe(
                data => onLoad(data),
                erro => this.util.alertResult(erro));

    }

    //PRINTER
    printerBill(printerID) {

        let loading = this.util.loadingDots();
        loading.present();

        let params = '&PrinterID=' + printerID + '&ComandaID=' + this.rootComanda.Comandas[0].ComandaID;
        this.util.monitorDesk(true, 'DESK-Printer', this.hotspotID, params, TAction.acBill)
            .finally(() => loading.dismiss())
            .subscribe(
                data => this.util.toastSimply('Míssil de conta enviado!', 3000, () => this.dismiss()),
                erro => this.util.alertResult(erro));

    }

    
    paybookLoad(paybook, userset) {

        //Não passei o param "paybook: paybook" para carregar a comanda novamente e nao perder o "consumo lançado" nesse pedido especifico.

        let requestIpad = (this.etapa == 10);

        let branded = this.monitorAuth.Hotspot.Branded;
        let object = {etapa: 0, olhaapp: false, monitorBool: true, requestIpad: requestIpad, fronter: false, profile: paybook.Profile, branded: branded, workday: true, userset: userset, paybookID: paybook.PaybookID, paybook: null};
        this.util.modalopen(PaybookMenuPage, 'alto', false, object).subscribe(data => {

            if (requestIpad && data.paybookAuth) this.dismiss();

        });

    }

    comandaErro(erro) {

        this.requestErro = erro;
        this.paybookSair = null;

        setTimeout(() => {
            this.requestErro = null;
            this.paybookSair = null;
            this.tecladoOkey('erase');
        }, 4000);

    }

    comandaFind() {

        let rnid = this.util.validaCNPF(this.comandaText);

        let onPush = (data) => {

            let paybook = (data.Comandas || [])[0];
            let userset = (data.Usuarios || [])[0];
            let paycria = !paybook && (this.comandaText.length < 4 || this.monitorAuth.Hotspot.SettingAlma == TProfileAlma.paLancaki);
            let comandaTipo = (this.comandaText.length < 4 ? TPaybookTipo.pbMesa : TPaybookTipo.pbCard);

            if (!paybook && this.etapa == 1 &&  paycria) this.comandaCria(this.comandaText, userset, comandaTipo)
            if ( paybook && this.etapa == 1 && !paycria) this.paybookLoad(paybook, userset);
            if ( paybook && this.etapa == 2            ) this.paybookLoad(paybook, userset);
            if (!paybook && !paycria) this.util.toastSimply('Não encontrado');
            if (!paycria) this.tecladoOkey('erase');

        };

        let loading = this.util.loadingDots();
        loading.present();

        let params = '&ComandaText=' + this.comandaText +
                     '&ComandaMode=' + (rnid ? TAcessoFind.afFindRnid : TAcessoFind.afFindNoro);

        this.util.monitorDesk(true, 'DESK-Comanda', this.hotspotID, params, TAction.acFind)
            .finally(() => loading.dismiss())
            .subscribe(
                data => onPush(data),
                erro => this.comandaErro(erro)
            );

    }

    comandaSair() {

        let rnid = this.util.validaCNPF(this.comandaText);

        let onPush = (data) => {

            let paybook = (data.Comandas || [])[0];

            if ( paybook) this.comandaExit(paybook);
            if (!paybook) this.util.toastSimply('Não encontrado');
            this.tecladoOkey('erase');

        }

        let loading = this.util.loadingDots();
        loading.present();

        let params = '&ComandaText=' + this.comandaText +                     
                     '&ComandaMode=' + (rnid ? TAcessoFind.afFindRnid : TAcessoFind.afFindNoro);

        this.util.monitorDesk(true, 'DESK-Started', this.hotspotID, params, TAction.acSair)
            .finally(() => loading.dismiss())
            .subscribe(
                data => onPush(data),
                erro => this.comandaErro(erro)
            );

    }

    comandaExit(paybook) {
        
        let onExit = (root) => {

            //Timeout para mostrar a foto
            this.requestErro = null;
            this.paybookSair = paybook;
            paybook.Outbook = root.Comandas[0].Outbook;

            let object = {etapa: 3, paybook: paybook};
            this.navCtrl.push(EntrakiOpenPage, object, {animation: 'md-transition'}).then();

            setTimeout(() => {
                this.paybookSair = null;
                setTimeout(() => this.tecladoOkey('erase'), 1000);
            }, 4000);
    
        };
        
        let loading = this.util.loadingDots();
        loading.present();

        let params = '&ComandaID=' + paybook.ComandaID;

        this.util.monitorDesk(true, 'DESK-Started', this.hotspotID, params, TAction.acExit)
            .finally(() => loading.dismiss())
            .subscribe(
                root => onExit(root),
                erro => this.comandaErro(erro)
            );

    }

    
    dismiss() {

        if (this.etapa == 2 || this.etapa == 10) {
            this.etapa = 2;
            this.tecladoOkey('erase');
            
            this.logadoService.logout();
        }

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/desktop-menu/desktop-menu.ts